export const CSSVarHeaderHeight = "var(--header-height)";
